module.exports = __webpack_public_path__ + "img/young_soft_design_ico.2fae0382.png";